const ABFieldLongTextCore = require("../../core/dataFields/ABFieldLongTextCore");
module.exports = class ABFieldLongText extends ABFieldLongTextCore {};
